export const channelThresholdExternalSteps = [
  {
    selector: "#channel-card-title",
    content:
      "This area provides the name of the channel.",
  },
  {
    selector: "#use-default-thresholds-button",
    content:
      "Push this button to apply the default threshold values to this specific channel only.",
  },
  {
    selector: "#queue-thresholds-select",
    content:
      "This selection is to set the threshold for the number of queued messages the channel must reach before system event notification is triggered.",
  },
  {
    selector: "#error-thresholds-select",
    content:
      "This selection is to set the threshold for the number of errored messages the channel must reach before system event notification is triggered.",
  },
  {
    selector: "#inactivity-thresholds-select",
    content:
      "This selection is to set the threshold for the number of minutes a channel does not receive a message before system event notification is triggered.",
  },
  {
    selector: "#poll-frequency-select",
    content:
      "The poll frequency when the above threshold values should be evaluated.",
  },
  {
    selector: "#prune-settings-select",
    content:
      "This is the prune settings.",
  },
  {
    selector: "#message-storage-mode-select",
    content:
      "This is the message storage mode select.",
  },
  {
    selector: "#threshold-values-reset-button",
    content:
      "Push this button to reset the above values to the previous settings.",
  },
  {
    selector: "#update-default-threshold-all-channels-button",
    content:
      "Press this button to apply the default threshold values to all channels in this environment.  Press the 'Update Button' after to apply the changes.",
  },
  {
    selector: "#update-channels-button",
    content:
      "Press this button to apply the changes.  This button will be disabled unless there have been changes made above.",
  },
];
